import moment from "moment";
import React, { useMemo } from "react";
import Loader from "../../../../../../components/Loader";
import { useHistory } from "../../../../../../utils/reactQuery/worklog";
import HistoryItem from "./HistoryItem";

function History({ cardId }) {
  const { isLoading, history } = useHistory(cardId);

  const sortedHistory = useMemo(() => {
    if (!history?.data?.data?.responseData) return [];
    
    return history.data.data.responseData.sort((a, b) => {
      const dateA = moment(a.at_time);
      const dateB = moment(b.at_time);
      return dateB - dateA;
    });
  }, [history]);
  
  return (
    <>
      {isLoading ? (
        <div className="loader-center">
        <Loader color={"black"} />
        </div>
      ) : (
        <>
          <div>
            {sortedHistory?.map((el,i)=> <HistoryItem key={`historys-${i}`} history={el}/>)}
          </div>
        </>
      )}
    </>
  );
}

export default React.memo(History);
